<nav [attr.aria-label]="navAriaLabel">
  <ul>
    @if (flyout && (node?.children?.length ?? 0) > 1) {
      <li
        class="back is-open"
        >
        <button (click)="back()">
          <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
          {{ 'common.back' | cxTranslate }}
        </button>
      </li>
    }

    @for (child of node?.children; track child) {
      <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }">
      </ng-container>
    }
  </ul>
</nav>
<!-- we generate links in a recursive manner -->

<ng-template #nav let-node="node" let-depth="depth">
  <li>
    @if (
      node.url && (!node.children || node.children?.length === 0)) {
      <cx-generic-link
        [url]="node.url"
        [target]="node.target"
        [style]="node.styleAttributes"
        [class]="node.styleClasses"
        (click)="closeIfClickedTheSameLink(node)"
        >
        {{ node.title }}
      </cx-generic-link>
    } @else {
      @if (flyout && node.children?.length > 0) {
        @if (node.url) {
          <cx-generic-link
            [url]="node.url"
            [target]="node.target"
            (click)="closeIfClickedTheSameLink(node)"
            >
            {{ node.title }}
          </cx-generic-link>
        }
        <button
          [attr.tabindex]="depth < 1 ? 0 : -1"
          [attr.aria-haspopup]="true"
          [attr.aria-expanded]="false"
          [attr.aria-label]="node.title"
          (click)="toggleOpen($any($event))"
          (mouseenter)="onMouseEnter($event)"
          (keydown.space)="toggleOpen($any($event))"
          (keydown.esc)="back()"
          >
          @if (!node.url) {
            {{ node.title }}
          }
          <cx-icon [type]="iconType.CARET_DOWN"></cx-icon>
        </button>
      } @else {
        <span [attr.tabindex]="-1">
          {{ node.title }}
        </span>
      }
    }


    <!-- we add a wrapper to allow for better layout handling in CSS -->
    @if (node.children && node.children.length > 0) {
      <div class="wrapper2">
        <ul
          class="childs"
          [attr.depth]="getTotalDepth(node)"
          [attr.wrap-after]="node.children.length > wrapAfter ? wrapAfter : null"
          [attr.columns]="getColumnCount(node.children.length)"
          >
          @for (child of node.children; track child) {
            <ng-container
              *ngTemplateOutlet="nav; context: { node: child, depth: depth + 1 }"
              >
            </ng-container>
          }
        </ul>
      </div>
    }
    @if (node.uid=='addresspara') {
      @if (addressData$|async; as address) {
        <div>
          <p [innerHTML]="address['content']"></p>
        </div>
      }
    }
    @if (node.uid=='socialMediaIconsPara') {
      @if (socialMedia$|async; as socialMedia) {
        <div>
          <p [innerHTML]="socialMedia['content']"></p>
        </div>
      }
    }
    @if (node.uid=='addressparaKB') {
      @if (addressparaKB$|async; as addressPara) {
        <div>
          <p [innerHTML]="addressPara['content']"></p>
        </div>
      }
    }
    @if (node.uid=='socialMediaIconsParaKB') {
      @if (socialMediaIconsKB$|async; as socialMediakb) {
        <div>
          <p [innerHTML]="socialMediakb['content']"></p>
        </div>
      }
    }
  </li>
</ng-template>
